export const SamanthaEvents = {
  pornEventRecordings: 0
};

SamanthaEvents.hasActiveEvent = () => {
  return SamanthaEvents.isSecondEvent() ||
    SamanthaEvents.isThirdEvent() ||
    SamanthaEvents.isFourthEvent() ||
    SamanthaEvents.isFifthEvent() ||
    SamanthaEvents.isSixEvent()
    ;
}

SamanthaEvents.displayHint = () => {
  return SamanthaEvents.isSecondEvent() ||
    SamanthaEvents.isThirdEvent() ||
    SamanthaEvents.isFourthEvent() ||
    SamanthaEvents.isFifthEvent() ||
    SamanthaEvents.isSixEvent() ||
    SamanthaEvents.pornRecording()
    ;
}

SamanthaEvents.isWaifu = () => {
  return EventStateService.isSamanthaWaifu;
}

SamanthaEvents.genericTalk = () => {
  return !SamanthaEvents.hasActiveEvent() && !SamanthaEvents.isFourthEvent();
}

SamanthaEvents.isFirstEvent = () => {
  if(EventStateService.samanthaDailyEventChecked) {
    return false;
  }

  if(!Yosemite.EventStateManager.anastasiaFirstSexEvent) {
    return false;
  }

  // czy już drugi rozdział
  if(!EventStateService.secondChapterIntro) {
    return false;
  }

  // musi być wieczór
  if(YsControllers.TimeController.getCurrentDayTime() !== YsControllers.TimeController.DayTimeEnum.EVENING) {
    return false;
  }

  return !EventStateService.samanthaFirstEvent;
}

SamanthaEvents.isSecondEvent = () => {
  if(EventStateService.samanthaDailyEventChecked) {
    return false;
  }

  // czy już był pierwszy event
  if(!EventStateService.samanthaFirstEvent) {
    return false;
  }

  return !EventStateService.samanthaSecondEvent;
}

SamanthaEvents.isThirdEvent = () => {
  if(EventStateService.samanthaDailyEventChecked) {
    return false;
  }

  // czy już był drugi event
  if(!EventStateService.samanthaSecondEvent) {
    return false;
  }

  return !EventStateService.samanthaThirdEvent;
}

SamanthaEvents.isFourthEvent = () => {
  if(EventStateService.samanthaDailyEventChecked) {
    return false;
  }

  // czy już był trzeci event
  if(!EventStateService.samanthaThirdEvent) {
    return false;
  }

  return !EventStateService.samanthaFourthEvent;
}

SamanthaEvents.isFifthEvent = () => {
  if(EventStateService.samanthaDailyEventChecked) {
    return false;
  }

  // czy już był czwarty event
  if(!EventStateService.samanthaFourthEvent) {
    return false;
  }

  return !EventStateService.samanthaFifthEvent;
}

SamanthaEvents.isSixEvent = () => {
  if(EventStateService.samanthaDailyEventChecked) {
    return false;
  }

  // czy już był piąty event
  if(!EventStateService.samanthaFifthEvent) {
    return false;
  }

  return !EventStateService.samanthaSixEvent;
}

//Event 7 - porno movie
SamanthaEvents.pornRecording = () => {
  if(EventStateService.samanthaDailyEventChecked) {
    return false;
  }

  // czy już był szósty event
  if(!EventStateService.samanthaSixEvent) {
    return false;
  }

  return !EventStateService.samanthaPornRecordingEvent;
}
